// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isEqual = (value: any, other: any): boolean => {
  if (Object.is(value, other)) {
    return true;
  }

  if (value == null || other == null || typeof value !== typeof other) {
    return value === other;
  }

  if (value instanceof Date && other instanceof Date) {
    return value.getTime() === other.getTime();
  }

  if (typeof value !== 'object') {
    return value === other;
  }

  if (Array.isArray(value) !== Array.isArray(other)) {
    return false;
  }

  if (Array.isArray(value)) {
    return value.length === other.length && value.every((item, index) => isEqual(item, other[index]));
  }

  const keys = Object.keys(value);
  return keys.length === Object.keys(other).length && keys.every(key => isEqual(value[key], other[key]));
};

export const clone = <T>(value: T): T => {
  if (Array.isArray(value)) {
    return value.slice() as T;
  }

  if (value !== null && typeof value === 'object') {
    return { ...(value as object) } as T;
  }

  return value;
};

export const cloneDeep = <T>(value: T): T => {
  if (value === null || typeof value !== 'object') {
    return value;
  }

  if (value instanceof Date) {
    return new Date(value.getTime()) as T;
  }

  if (Array.isArray(value)) {
    return value.map(item => cloneDeep(item)) as T;
  }

  const result = Object.create(Object.getPrototypeOf(value));

  Object.keys(value as object).forEach(key => {
    result[key] = cloneDeep((value as Record<string, unknown>)[key]);
  });

  return result;
};
